import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../../common/locale/translate';

export default class HotelNameForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      hotel_name: props.hotel_name,
      active_modal: false,
      active_input: false
    };

    this.inputRef = null;
    this.setInputRef = element => {
      this.inputRef = element;
    };

    this.modalRef = null;
    this.setModalRef = element => {
      this.modalRef = element;
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    document.addEventListener('click', this.handleLoseFocus.bind(this), true);
  };

  render() {
    return (
      <section className="search-form wrapper">
        <div className="mobile-action-wrapper">
          <button onClick={this.handleMobileToggle} className="search-button">
            {T('search_for_hotel')} <i className="fa fa-search" />
          </button>
        </div>
        <div
          className={`search-form-outside-wrapper ${
            this.state.active_modal ? 'active' : ''
          }`}
        >
          <div className="mobile-header-wrapper">
            <h3 className="mobile-header">
              {' '}
              {T('filter_results')}{' '}
              <i
                className="fa fa-times mobile-toggle-switch"
                aria-hidden="true"
              />{' '}
            </h3>
          </div>
          <div className="search-form-inside-wrapper" ref={this.setModalRef}>
            <section className="panel basic-filters open">
              <h5 className="header">{T('search_for_hotel')}</h5>
              <article className="content">
                <div className="inner-wrapper">
                  <div
                    className={`hotel-name select-wrapper animated-text-form extended
                    ${this.state.active_input ? 'active' : ''}`}
                  >
                    <label className="animated-text-label">
                      <span className="animated-text-label-name">
                        {T('hotel_name_filter')}
                      </span>
                    </label>
                    <input
                      ref={this.setInputRef}
                      type="text"
                      value={this.state.hotel_name}
                      className="animated-text-input"
                      onFocus={this.handleFocus}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="action-wrapper">
                  <button onClick={this.handleSearch} className="search-button">
                    <i className="fa fa-search" /> {T('look_for')}
                  </button>
                </div>
              </article>
            </section>
          </div>
        </div>
      </section>
    );
  }

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
    }
    this.setState({ active_modal: !this.state.active_modal });
  };

  handleChange = event => this.setState({ hotel_name: event.target.value });

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this.modalRef);
    if (
      (!domNode || !domNode.contains(event.target)) &&
      this.state.active_modal
    ) {
      this.handleMobileToggle();
    }
  };

  handleLoseFocus = event => {
    const domNode = ReactDOM.findDOMNode(this.inputRef);
    if (
      (!domNode || !domNode.contains(event.target)) &&
      this.state.active_input
    ) {
      this.setState({ active_input: false });
    }
  };

  handleFocus = () => {
    this.setState({ active_input: true });
  };

  handleSearch = () => {
    this.props.search(this.state.hotel_name);
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/HotelNameForm.jsx